import React from 'react';
import { demonstrationContent } from '@anonymizePro/mock/contents';

function SubmitForm() {
    return (
        <React.Fragment>
            <p className="anonymize-h2 text-center text-black-800">{demonstrationContent.thankYouTitle}</p>
            <p className="anonymize-p4 my-4 max-w-[500px] text-center  text-black-700">{demonstrationContent.thankYouPrimaryDescription}</p>
            <p className="anonymize-p4 mb-12 max-w-[404px] text-center text-black-700">{demonstrationContent.thankYouSecondaryDescription}</p>
        </React.Fragment>
    );
}

export default SubmitForm;
